import styled from 'styled-components';


export const ContactUsBanner = styled.section`

    @media screen and (max-width:575px) {
        margin-top: 100px;
    }
    .blue-banner {
        display: block;
    }
    .search-header{
        display:none;
    }
    .row{
        align-items: center;
    }

    .write-review-banner{
        width: 100%;
        
        @media screen and (max-width:1024px){
            padding: 180px 0px 144px;
        }
        
        @media screen and (max-width:991px){
            padding: 180px 0px 50px;
        }

        @media screen and (max-width:575px){
            padding: 50px 0px 40px;
        }
    }
    .review-right-image{
        max-width: 568px;

        @media screen and (max-width:991px){
            max-width: 100%;
            max-height: 100%;
        }

        img{
            width: 100%;
            height: 100%;
            display: block;
            object-fit: cover;
        }
    }
`;

export const ContactUsFaq = styled.div`
    background: #F1FEFF 0% 0% no-repeat padding-box;
    padding:50px 0;

    @media screen and (max-width:575px){
        padding:40px 0;
    }
`;

export const FaqContact = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 15px;
    padding:30px;
    width:100%;
    max-width:996px;
    margin:0 auto;

    button{
        padding: 12px 114px;
    }
    @media screen and (max-width:575px) {
        padding:20px;
    }
        
    .accordion-button {
        padding: 0 !important;
        background: transparent;
        border: none !important;
        display: flex;
        align-items: center;
        box-shadow:none;
        color: #01606F;
        font-family: "Jost", sans-serif;
        font-size:18px;
        font-weight: 400;
        line-height:27px;
        margin-bottom: 0px;
        width: auto !important;
        &:after{
            display:none !important;
          }
    }
    .accordion-item {
        border: none;
    }
    .accordion-body{
        border: none !important;
        background: #F2F2F2 0% 0% no-repeat padding-box;
        border-radius: 15px;
        padding: 20px;
        font-size: 18px;
        color: #333333;
        line-height: 27px;
        font-family: "Jost", sans-serif;
        margin-top: 20px;

       strong{
          color:#01606F;
          font-weight:700;
       } 
       p{
        margin-bottom: 20px !important;
        &:nth-child(2){
            margin-bottom: 0px !important;
        }
        &:nth-child(4){
            margin-bottom: 0px !important;
        }
       &:last-child{
        margin-bottom: 0px !important;
       } 
      }
    }

    .accordion-wrapper{
        width: 100%;
        display: flex;
        flex-direction: column;
        row-gap: 20px;
    }

    .btn-outline-success-blue{
        margin-top: 30px;

        @media screen and (max-width:480px){
            padding: 12px 30px;
            width: 100%;
        }
    }
`;


export const FaqContactTitle = styled.h2`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight: 700;
    line-height:45px;
    margin-bottom: 15px;
   
    @media screen and (max-width:575px) {
        font-size: 25px;
        line-height:30px;
    }
     
`;



